import Container from '@material-ui/core/Container';
import { Theme, makeStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import React, { forwardRef } from 'react';

import { Grid, GridGutter, GridProps } from 'src/components/Grid/Grid';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '--grid-container-gutter': `${theme.spacing(GridGutter.mobileOrTablet)}px`,
    'padding': '0 var(--grid-container-gutter)',
    [theme.breakpoints.up('lg')]: {
      '--grid-container-gutter': `${theme.spacing(GridGutter.desktop)}px`,
    },
    [theme.breakpoints.up('xl')]: {
      '--grid-container-gutter': `${theme.spacing(GridGutter.desktopLarge)}px`,
    },
  },
}));

export interface GridContainerProps extends Omit<GridProps, 'container' | 'item'> {
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number;
  containerClassName?: string;
}

export const GridContainer = forwardRef<HTMLDivElement, GridContainerProps>(({
  maxWidth: defaultMaxWidth = 'xl',
  containerClassName,
  ...props
}, ref) => {
  const classes = useStyles();
  const maxWidth = typeof defaultMaxWidth === 'number' ? undefined : defaultMaxWidth;
  const style = typeof defaultMaxWidth === 'number' ? { maxWidth: getMaxWidth(defaultMaxWidth) } : undefined;

  return (
    <Container maxWidth={maxWidth} className={cx(classes.container, containerClassName)} data-test="grid-container" ref={ref} style={style}>
      <Grid container {...props} />
    </Container>
  );
});

GridContainer.displayName = 'GridContainer';

export const getMaxWidth = (width: number): string => `calc(${width}px + var(--grid-container-gutter) * 2)`;
